/** Matches server tombstone: Person with isDeleted === true. */
export function isSoftDeletedPerson(
  person: { isDeleted?: boolean } | null | undefined,
): boolean {
  return person?.isDeleted === true;
}
